export const pmaxCampaignsQueryKey = ["pmax-campaigns"];
export const pmaxAssetGroupsQueryKey = ["asset-groups"];
